// extracted by mini-css-extract-plugin
export default {"dash":"Body_dash__uJ-ob"};